import { Action } from "@ngrx/store";
import { IServerResponse } from "app/interface";
import {
    USER_TO_BILL_LIST, GET_USER_TO_BILL_LIST, SAVE_USER_TO_BILL, SAVE_USER_TO_BILL_RESP,
    DELETE_USER_TO_BILL, DELETE_USER_TO_BILL_RESP
} from "./actionTypes";

export class GetUserToBillList implements Action {
    readonly type = GET_USER_TO_BILL_LIST;
}

export class UserToBillList implements Action {
    readonly type = USER_TO_BILL_LIST;
    readonly payload = []
    constructor(userToBillList: Array<any>) {
        this.payload = userToBillList;
    }
}

export class SaveUserToBill implements Action {
    readonly type = SAVE_USER_TO_BILL;
    readonly payload;
    constructor(data) {
        this.payload = data;
    }
}

export class SaveUserToBillResp implements Action {
    readonly type = SAVE_USER_TO_BILL_RESP;
    readonly payload: IServerResponse;
    constructor(resp) {
        this.payload = resp
    }
}

export class DeleteUserToBill implements Action {
    readonly type = DELETE_USER_TO_BILL;
    readonly payload;
    constructor(data) {
        this.payload = data;
    }
}

export class DeleteUserToBillResp implements Action {
    readonly type = DELETE_USER_TO_BILL_RESP;
    readonly payload: IServerResponse;
    constructor(resp) {
        this.payload = resp
    }
}

export type Actions = GetUserToBillList | UserToBillList | SaveUserToBill | SaveUserToBillResp |
    DeleteUserToBill | DeleteUserToBillResp;
